export const AlertType = {
	SUCCESS: 'success',
	ERROR: 'error',
};